<template>
  <v-container>
    <v-snackbar app v-model="show" right :color="color" :timeout="3000">
      {{ message }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Snackbars',
  data: () => ({
    show: false,
    message: '',
    color: 'success'
  }),
  computed: {
    ...mapGetters({
      snackColor: 'snackbar/getSnackColor',
      snackMessage: 'snackbar/getSnackMessage'
    })
  },
  created() {
    this.$store.watch(
      state => state.snackbar.snackMessage,
      () => {
        const msg = this.snackMessage
        if (msg !== '') {
          this.message = msg
          this.color = this.snackColor
          this.show = true
        }
      }
    )
  }
}
</script>

<style scoped></style>
